import { createContext, Dispatch, SetStateAction } from 'react';

import { Providers, SelectOption } from '../../interfaces';
import { QuotationGroups } from '../../../pages/quotation/NewQuote/containers';
import { GlobalPublicConfigs } from '../../interfaces/services/global-config-service';

interface MasterContextProps {

    /** List of Countries for use in Select */
    countryList:                        Array<SelectOption> | undefined;
    getCountryList:                     () => Promise<void>

    /** List of Provinces of Argentina for use in Select */
    getProvincesList:                   () => Promise<void>;
    provinceList?:                      Array<SelectOption>;
    isLoadingProvinceList:              boolean;
    
    /** List of Different Document Types for use in Select */
    documentTypeList?:                  Array<SelectOption>;
    getDocumentTypeList:                () => Promise<void>;
    isLoadingDocumentTypeList:          boolean;
    
    /** List of localities per province of Argentina for use in Select */
    getLocalitiesByProvinceFromState:   ( provinceCode: string ) => Array<SelectOption> | undefined;
    getLocalitiesList:                  any;
    setLocalities:                      any;
    isLoadingLocalities:                boolean;
  
    allLocalitiesPerProvince:           Array<{ provinceCode: string; localitiesOptions: Array<SelectOption> }>
    branchList?:                        Array<SelectOption>;
    getBranchsList:                     () => Promise<void>;
    isLoadingBranchList:                boolean;

    /** List of genders for use in Select */
    genderList:                         Array<SelectOption>;
    getGenderList:                      () => Promise<void>;
    isLoadingGenderList:                boolean;
    
    /** List of Civil status for use in Select */
    civilStatusList:                    Array<SelectOption>;
    getCivilStatusList:                 () => Promise<void>;
    isLoadingCivilStatusList:           boolean;

    getAccidentTypeList:                () => Promise<void>;
    accidentTypeList:                   Array<SelectOption>;
    isLoadingAccidentTypeList:          boolean;

    getCollisionWithList:               () => Promise<void>;
    collisionWithList:                  Array<SelectOption>;
    isLoadingCollisionWithList:         boolean;

    getProvidersList:                   (param: any) => Promise<void>
    providersList:                      Providers[];
    isLoadingProvidersList:             boolean;
    
    getVehicleTypesList:                () => Promise<void>;
    vehicleTypesList:                   Array<SelectOption>;
    isLoadingVehicleTypesList:          boolean;

    getUseList:                         () => Promise<void>;
    useList:                            Array<SelectOption>;
    isLoadingUseList:                   boolean;

    getYearList:                        () => Promise<void>;
    yearList:                           Array<SelectOption>;
    isLoadingYearList:                  boolean;

    getVehicleBrandsList:               (rama: string) => Promise<void>;
    vehicleBrandList:                   Array<SelectOption>;
    isLoadingVehicleBrandList:          boolean;

    getVehicleModelsPerBrandList:        (codigoMarcaInfoauto: string) => Promise<void>;
    vehicleModelsPerBrandList:           any;
    setVehicleModelsPerBrandList:        any;
    isLoadingVehicleModelsPerBrandList:  boolean;

    savedQuotationInfo:                 { quotationNumber: string, quotationGroup: QuotationGroups } | undefined;
    setSavedQuotationInfo:              Dispatch<SetStateAction<{ quotationNumber: string, quotationGroup: QuotationGroups } | undefined>>;

    globalPublicConfigs:                GlobalPublicConfigs | undefined;
    setGlobalPublicConfigs:             Dispatch<SetStateAction<GlobalPublicConfigs | undefined>>;
}   

export const MasterContext = createContext({} as MasterContextProps);